import { Head, Layout, Title } from '@/components'
import { MailIcon } from '@heroicons/react/outline'

const faqs = [
  {
    question: 'Who is this? Like, really. This has to be owned by some big company.',
    answer:
      'Good Neighbour is a project by Really Good Work Inc. An independent design and development studio focused on creating great things',
  },
  {
    question: "I had an account on the old site but now I can't log in with Google or Facebook.",
    answer:
      'In an effort to maintain anonymity and privacy, we did away with passwords. In order to get your account working again, first log in with the email attached to your Google or Facebook account. Once logged in, open a new tab and log in again with your Social account.',
  },
  // More questions...
]

export default function Contact() {
  return (
    <Layout className="relative">
      <div className="bg-topography bg-cover bg-fixed absolute inset-0 dark:opacity-10 opacity-[2%] " />
      <Head title="Contact" description="Contact Good Neighbour" />
      <div className="max-w-7xl mx-auto py-8 relative">
        <div className="py-16 sm:py-24">
          <div className="max-w-md mx-auto pl-4 pr-8 sm:max-w-lg sm:px-6 lg:max-w-7xl lg:px-8">
            <Title size="2xl" className="text-center">
              Get in touch
            </Title>
            <p className="mt-3 sm:mt-6 max-w-3xl mx-auto sm:text-lg leading-normal text-center mb-4 dark:text-zinc-400 text-zinc-500 font-medium">
              Say hi, tell us a joke, send us your favourite recipes.
            </p>
          </div>
          <div className="mt-6 flex justify-center text-brand-500">
            <div className="flex-shrink-0">
              <MailIcon className="h-6 w-6 text-brand-500" aria-hidden="true" />
            </div>
            <div className="ml-3 text-base text-brand-500">
              <p>
                <a href="mailto:howdy@goodnbr.co">howdy@goodnbr.co</a>
              </p>
            </div>
          </div>
          <ul role="list" className="mt-8 flex space-x-12 justify-center">
            <li>
              <a
                className="text-brand-500 hover:text-brand-400 inline-flex space-x-2"
                href="https://instagram.com/goodnbrco"
              >
                <span className="sr-only">Instagram</span>

                <svg
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  width={24}
                  height={24}
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>@goodnbrco</span>
              </a>
            </li>
            <li>
              <a
                className="inline-flex space-x-2 text-brand-500 hover:text-brand-400"
                href="https://twitter.com/goodnbrco"
              >
                <span className="sr-only">Twitter</span>
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  aria-hidden="true"
                >
                  <path
                    d="M7.548 22.501c9.056 0 14.01-7.503 14.01-14.01 0-.213 0-.425-.015-.636A10.02 10.02 0 0024 5.305a9.828 9.828 0 01-2.828.776 4.94 4.94 0 002.165-2.724 9.867 9.867 0 01-3.127 1.195 4.929 4.929 0 00-8.391 4.491A13.98 13.98 0 011.67 3.9a4.928 4.928 0 001.525 6.573A4.887 4.887 0 01.96 9.855v.063a4.926 4.926 0 003.95 4.827 4.917 4.917 0 01-2.223.084 4.93 4.93 0 004.6 3.42A9.88 9.88 0 010 20.289a13.941 13.941 0 007.548 2.209"
                    fill="currentColor"
                  />
                </svg>
                <span>@goodnbrco</span>
              </a>
            </li>
          </ul>
        </div>
        {/* Contact Section */}
      </div>
      <div className="bg-brand-500  relative" id="faq">
        <div className="max-w-7xl mx-auto py-16 lg:py-32 px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-3 lg:gap-6">
            <div>
              <Title as="h2" size="2xl" className="!text-white">
                Frequently Asked Questions
              </Title>
              <p className="mt-4 leading-normal mb-4 text-nordic  font-medium text-base sm:text-lg">
                Can’t find the answer you’re looking for?
                <br /> Reach out to our{' '}
                <a href="mailto:howdy@goodnbr.co" className="font-semibold text-brand-10 underline">
                  support
                </a>{' '}
                team.
              </p>
            </div>
            <div className="mt-12 lg:mt-0 lg:col-span-2">
              <dl className="space-y-12">
                {faqs.map((faq) => (
                  <div key={faq.question}>
                    <dt className="text-lg leading-6 font-medium text-white">{faq.question}</dt>
                    <dd className="!leading-loose mt-2 text-base text-zinc-100 font-medium tracking-tight">
                      {faq.answer}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
